import { render, staticRenderFns } from "./MotorSelector.vue?vue&type=template&id=05f582ee&"
import script from "./MotorSelector.vue?vue&type=script&lang=js&"
export * from "./MotorSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports